import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router";
import { IconButton, Popover, Tooltip } from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import {
  flushBreadCrumps,
  getFullHistory,
} from "./M_BreadCrumbs.helper";
import "./M_NavigationHistory.css";

const M_NavigationHistory = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [entries, setEntries] = useState([]);
  const routerHistory = useHistory();
  const { pageUrl, crmId, templateId } = useParams();

  const isOpen = Boolean(anchorEl);

  useEffect(() => {
    if (isOpen) setEntries(getFullHistory());
  }, [pageUrl, crmId, templateId]);

  const handleOpen = (e) => {
    setEntries(getFullHistory());
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleNavigate = (entry) => {
    routerHistory.push(`/${entry.pageUrl}/${entry.crmId}/${entry.templateId}`);
    handleClose();
  };

  const handleClearAll = () => {
    flushBreadCrumps();
    setEntries([]);
  };

  const MAX_HISTORY = 10;
  const reversed = [...entries].reverse().slice(0, MAX_HISTORY);

  return (
    <>
      <Tooltip title="Navigation history" placement="bottom">
        <IconButton
          size="small"
          onClick={handleOpen}
          className={`navHistTrigger ${isOpen ? "navHistTrigger--open" : ""}`}
        >
          <HistoryIcon style={{ fontSize: 18, color: "var(--color-text-primary)" }} />
        </IconButton>
      </Tooltip>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ className: "navHistPaper" }}
      >
        <div className="navHistHeader">
          <span className="navHistHeaderLabel">Recently visited</span>
          {entries.length > 0 && (
            <Tooltip title="Clear history" placement="top">
              <IconButton
                size="small"
                onClick={handleClearAll}
                className="navHistClearBtn"
              >
                <DeleteSweepIcon style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          )}
        </div>

        {reversed.length === 0 ? (
          <div className="navHistEmpty">
            <div className="navHistEmptyIcon">
              <HistoryIcon style={{ fontSize: 18 }} />
            </div>
            <span className="navHistEmptyText">No pages visited yet</span>
            <span className="navHistEmptyHint">Pages you visit will appear here</span>
          </div>
        ) : (
          <>
            <ul className="navHistList">
              {reversed.map((entry, idx) => {
                const isCurrent =
                  entry.pageUrl === pageUrl &&
                  entry.crmId === crmId &&
                  entry.templateId === templateId;

                return (
                  <li
                    key={idx}
                    className={`navHistItem ${
                      isCurrent ? "navHistItem--current" : "navHistItem--link"
                    }`}
                    onClick={() => !isCurrent && handleNavigate(entry)}
                  >
                    <div className="navHistDot" />
                    <div className="navHistItemBody">
                      <span className="navHistItemTitle">{entry.title}</span>
                    </div>
                    {isCurrent && (
                      <span className="navHistCurrentBadge">current</span>
                    )}
                  </li>
                );
              })}
            </ul>
            <div className="navHistFooter">
              {reversed.length} page{reversed.length !== 1 ? "s" : ""} in session
            </div>
          </>
        )}
      </Popover>
    </>
  );
};

export default M_NavigationHistory;
